import { Colors } from "./colors";
import { Fonts } from "./fonts";

export const TagPadrao = {
  font: Fonts.body2,
  backgroundColor: Colors.background_1,
  fontColor: Colors.text,
  message: 'TECNOLOGIA',
}
